import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import { Pagination } from '@shared/models';

import {
  StoreStockRecallListContent,
  StoreStockRecallRequestSearchCriteria
} from '../../model/store-stock-recall-list.model';

export const loadStoreStockRecallListRequest = createAction(
  '[StoreStockRecallList] Load Store Stock Recall List Request',
  props<{ criteriaObj: StoreStockRecallRequestSearchCriteria }>()
);

export const loadStoreStockRecallListResponse = createAction(
  '[StoreStockRecallList] Load Store Stock Recall List Response',
  props<{ data: Pagination<StoreStockRecallListContent> }>()
);

export const storeStockRecallViewAction = createActionGroup({
  source: 'Store Stock Recall View',
  events: {
    View: props<{ docNo: string }>(),
    ViewResponse: props<{ response: StoreStockRecallListContent }>(),
    resetView: emptyProps()
  }
});
